import GenerateMultipleStudentsDataForm from "./GenerateMultipleStudentsDataForm";
import GenerateOneStudentsDataForm from "./GenerateOneStudentsDataForm";
export default function GenerateDataForm({ students, onDataGenerated }) {
  return (
    <>
      {students?.length === 1 && (
        <GenerateOneStudentsDataForm
          student={students[0]}
          onDataGenerated={onDataGenerated}
        />
      )}
      {students?.length > 1 && (
        <GenerateMultipleStudentsDataForm
          students={students}
          onDataGenerated={onDataGenerated}
        />
      )}
    </>
  );
}
